import React from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import Home from "../Home/Home";
import Pricing from "../Pricing/Pricing";
import { translation } from "../../assets/translation";
import {
  blogurl,
  careerurl,
  handleUrl,
  language,
  signupurl,
} from "../../assets/function";
import Aboutus from "../Aboutus/Aboutus";
import Info from "../Info/Info";
import Privacy from "../Privacy/Privacy";
import Refund from "../Refund/Refund";
import Terms from "../Terms/Terms";

let staticText = translation[language];

function AppRouter() {
  let navigate = useNavigate();
  // Scroll to the specific section when the button is clicked
  const scrollToSection = (sectionRef) => {
    window.scrollTo({
      top: sectionRef.current.offsetTop,
      behavior: "smooth",
    });
  };

  const handleNavItem = (item, event) => {
    if (item === staticText.pricing) {
      navigate("/pricing");
    } else if (item === staticText.aboutUs) {
      navigate("/aboutus");
    } else if (item === staticText.signUp) {
      handleUrl(signupurl, event);
    } else if (item === staticText.blog) {
      handleUrl(blogurl, event);
    } else if (item === staticText.career) {
      handleUrl(careerurl, event);
    }
  };

  return (
    <Box sx={styles.container}>
      <Navbar scrollToSection={scrollToSection} handleNavItem={handleNavItem} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/info" element={<Info />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/terms" element={<Terms />} />
        <Route
          path="/blog"
          element={() => {
            window.location.href = blogurl;
            return null;
          }}
        />
        <Route
          path="/career"
          element={() => {
            window.location.href = careerurl;
            return null;
          }}
        />
        <Route
          path="/signup"
          element={() => {
            window.location.href = signupurl;
            return null;
          }}
        />
        {/* Redirect to Home if no route matches */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
    </Box>
  );
}

export default AppRouter;

const styles = {
  container: {
    width: "100%",
  },
};
